import styled, { css } from 'styled-components';
import { Flex } from '@rebass/grid';
import { Icon } from '@hey-car/ui';

import { color, media, zIndex } from 'app/shared/styles_js/variables';
import { Button } from 'app/shared/components/Button/Button';

export const TokenWarningContainerSt = styled(Flex)`
  position: fixed;
  z-index: ${zIndex.overlay};
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
`;

export const IconSt = styled(Icon)`
  display: flex;
  flex: 0 1 64px;
  align-items: center;
  justify-content: center;
  color: ${color.white};
  font-size: 16px;

  &:hover {
    cursor: pointer;
  }

  ${media.md(css`
    color: ${color.brandSecondary};
  `)};
`;

export const ButtonSt = styled(Button)`
  flex: 1;
`;
